import { SvgIcon } from '@mui/material';
import React from 'react';

interface AppleIconProps {
  style?: React.CSSProperties;
}

export const AppleIcon = ({ style = {}, ...props }: AppleIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 15 17" style={{ width: `15px`, height: `17px`, ...style }}>
      <g id="Page-1">
        <g id="Social-Icons---Isolated">
          <path
            id="Apple"
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.76279 2.88546C10.2973 2.19543 10.7025 1.22014 10.556 0.224609C9.68232 0.285324 8.66114 0.844295 8.06529 1.57287C7.52212 2.23303 7.07571 3.21507 7.25006 4.1682C8.20515 4.19807 9.19089 3.6256 9.76279 2.88546ZM14.4836 12.25C14.1014 13.1019 13.9175 13.4826 13.4251 14.2372C12.7382 15.2906 11.7697 16.6022 10.5684 16.6119C9.50222 16.6234 9.22729 15.9131 7.77981 15.9218C6.33234 15.9295 6.03058 16.6253 4.96246 16.6147C3.76213 16.6041 2.84441 15.4207 2.15755 14.3673C0.235888 11.4241 0.0337577 7.96913 1.21875 6.1313C2.06176 4.82641 3.39141 4.06313 4.64058 4.06313C5.9118 4.06313 6.71169 4.76474 7.76449 4.76474C8.78567 4.76474 9.40739 4.06122 10.8779 4.06122C11.991 4.06122 13.1703 4.67125 14.0094 5.72364C11.2582 7.24055 11.7036 11.1928 14.4836 12.25Z"
            fill="black"
          />
        </g>
      </g>
    </SvgIcon>
  );
};
